module.exports = __webpack_public_path__ + "img/index_ps_02.7b8a8c7a.jpg";